import { render, staticRenderFns } from "./DistressalertssitrepGrid.vue?vue&type=template&id=eccf85be"
import script from "./DistressalertssitrepGrid.vue?vue&type=script&lang=js"
export * from "./DistressalertssitrepGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports